// @flow
import * as React from 'react';
import IconText from 'components/IconText';
import ReportState from 'components/ReportState';
import Hero from 'components/Hero';
import Community from 'components/Community';
import SurveyResult from 'components/SurveyResult';

class Dashboard extends React.Component<{}> {
  render() {
    return (
      <div className="animated fadeIn">
        <IconText icon="icon-heart" color="success" text="1" />
        <IconText icon="icon-bubble" color="primary" text="123" />

        <ReportState state="new" />
        <ReportState state="in-progress" />
        <ReportState state="deleted" />
        <ReportState state="finished" />
        <ReportState state="declined" />

        <Hero
          title="Was geht ab?"
          description="Das geht ab!"
          images={[]}
          createdAt={+new Date()}
          createdBy={{
            firstname: 'Constantin',
            lastname: 'Gavrilete',
            email: 'c.gavrilete@gmail.com',
          }}
          maxImages={4}
        />

        <Community communities={['Eschenau', 'Lilienfeld', 'Hohenberg']} />

        <SurveyResult title="Gesamt" votes={{ A: 3, B: 1, C: 2, D: 0 }} />
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js